import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, ref, watch } from "vue";

import store from "@/store";
import { isNumber } from "@/utils/numbers";


export default /*#__PURE__*/_defineComponent({
  __name: 'PercentageInput',
  props: {
    value: null,
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 5 },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }) {

const props = __props as { value: number, min: number, max: number, step: number, disabled: boolean };





/**
 * Time needed before the slider value is actually applied (in ms)
 */
const debounceTime = 500;

/**
 * How long to wait before auto-incrementing the selected value (in ms) and the interval of successive increments (in ms)
 */
const changeTime = 300, changeInterval = 150;

// General input logic

const innerValue = ref(props.value), input = ref<HTMLInputElement | null>(null);

const canApply = computed(() => {
	if (props.disabled || innerValue.value === Math.round(props.value) || debounceTimer || decreaseTimer || increaseTimer) {
		return false;
	}
	return isNumber(innerValue) && innerValue.value >= props.min && innerValue.value <= props.max;
});

function apply() {
	(input as any).isMenuActive = false;			// FIXME There must be a better solution than this
	if (canApply.value) {
		emit("input", innerValue.value);
	}
}

function updateValue(value: string) {
	innerValue.value = parseFloat(value);
}

watch(() => props.value, (to) => {
	const newValue = Math.round(to);
	if (innerValue.value !== newValue) {
		innerValue.value = newValue;
	}
});

// Numeric input logic

const numericInputs = computed(() => store.state.settings.numericInputs);

const items = computed(() => {
	if (store.state.settings.disableAutoComplete || !props.step) {
		return [];
	}

	const result = [];
	if (isNumber(props.min) && isNumber(props.max)) {
		for (let value = props.min; value <= props.max; value += props.step) {
			result.push(value);
		}
	} else {
		for (let i = 5; i >= 1; i--) {
			const lowerValue = props.value - props.step * i;
			if (lowerValue >= props.min) {
				result.push(lowerValue);
			}
		}
		for (let i = 1; i <= 5; i++) {
			const higherValue = props.value + props.step * i;
			if (higherValue > props.max) {
				break;
			}
			result.push(higherValue);
		}
	}
	return result;
});

// Slider logic

const useVuetify = () => {
	const vm = getCurrentInstance();
	return vm?.proxy?.$vuetify || undefined;
};

const canLock = computed(() => useVuetify()?.breakpoint.mobile);

const isLocked = ref(true);

// Continuous increment/decrement

const debounceTimer = ref<NodeJS.Timeout | null>(null), decreaseTimer = ref<NodeJS.Timeout | null>(null), increaseTimer = ref<NodeJS.Timeout | null>(null);

function applyStep(diff: number) {
	if (debounceTimer.value) {
		clearTimeout(debounceTimer.value);
	}
	innerValue.value = Math.round(Math.min(props.max, Math.max(props.min, innerValue.value + diff)));
	debounceTimer.value = setTimeout(debounce, debounceTime);
}

function debounce() {
	emit("input", innerValue.value);
	debounceTimer.value = null;
}

function mouseDown(increment: boolean) {
	if (increment) {
		increaseTimer.value = setTimeout(increase, changeTime);
	} else {
		decreaseTimer.value = setTimeout(decrease, changeTime);
	}
}

function mouseUp(increment: boolean) {
	if (increment && increaseTimer.value !== null) {
		clearTimeout(increaseTimer.value);
		increaseTimer.value = null;
	} else if (decreaseTimer.value !== null) {
		clearTimeout(decreaseTimer.value);
		decreaseTimer.value = null;
	}
}

function decrease() {
	applyStep(-props.step);
	decreaseTimer.value = setTimeout(decrease, changeInterval);
}

function increase() {
	applyStep(props.step);
	increaseTimer.value = setTimeout(increase, changeInterval);
}

return { __sfc: true,props, emit, debounceTime, changeTime, changeInterval, innerValue, input, canApply, apply, updateValue, numericInputs, items, useVuetify, canLock, isLocked, debounceTimer, decreaseTimer, increaseTimer, applyStep, debounce, mouseDown, mouseUp, decrease, increase }
}

})